// components/GoJSFunctionalDiagram.js
import React, { useEffect, useRef } from 'react';
import * as go from 'gojs';

function GoJSFunctionalDiagram({ modelData }) {
  const diagramRef = useRef(null);

  useEffect(() => {
    const $ = go.GraphObject.make;
    const myDiagram = $(go.Diagram, diagramRef.current, {
        "undoManager.isEnabled": true,
        allowZoom: true,
        minScale: 0.75,          // ⬅️ Minimum zoom level (e.g., 75%)
        maxScale: 2.0,           // ⬅️ Maximum zoom level (e.g., 200%)
        allowHorizontalScroll: true,
        allowVerticalScroll: true,
        scrollMode: go.Diagram.InfiniteScroll, // or use DocumentScroll
        layout: $(go.LayeredDigraphLayout, {
          direction: 0,
          layerSpacing: 150,
          columnSpacing: 150,
          setsPortSpots: false
        })
      });      

    function makePort(name, spot) {
      return $(go.Shape, "Circle", {
        fill: "gray",
        stroke: null,
        desiredSize: new go.Size(8, 8),
        alignment: spot,
        alignmentFocus: spot,
        portId: name,
        fromSpot: spot,
        toSpot: spot,
        fromLinkable: true,
        toLinkable: true,
        cursor: "pointer"
      });
    }

    myDiagram.nodeTemplate =
      $(go.Node, "Spot",
        { resizable: false, locationSpot: go.Spot.Center },
        $(go.Shape, "Rectangle",
          { fill: "#eeeeee", stroke: "black", strokeWidth: 1.5, width: 100, height: 60 }),
        makePort("T", go.Spot.Top),
        makePort("L", go.Spot.Left),
        makePort("R", go.Spot.Right),
        makePort("B", go.Spot.Bottom),
        $(go.TextBlock,
            {
              font: "bold 14px sans-serif",
              editable: false,
              wrap: go.TextBlock.WrapFit,
              width: 100, // You can increase this for more wrapping room
              overflow: go.TextBlock.OverflowEllipsis
            },
            new go.Binding("text", "label"))          
      );

      myDiagram.linkTemplate =
      $(go.Link,
        {
          routing: go.Link.AvoidsNodes,  // ⬅️ Avoid overlapping nodes
          curve: go.Link.JumpOver,       // ⬅️ Show jumps for intersecting links
          corner: 10,
          relinkableFrom: true,
          relinkableTo: true,
          reshapable: true,
          resegmentable: true
        },
        $(go.Shape, { strokeWidth: 3 }),
        $(go.Shape, { toArrow: "Standard", stroke: null }),
        $(go.Shape, { fromArrow: "Standard", stroke: null }),
        $(go.TextBlock,
            {
              segmentOffset: new go.Point(0, -10), // move label above the edge
              segmentOrientation: go.Link.OrientUpright, // keep text readable
              font: "bold 14px sans-serif",
              stroke: "black",
              background: "rgba(255,255,255,0.8)", // optional: add background for clarity
              editable: false
            },
            new go.Binding("text", "label"))          
      );
    

    if (modelData) {
      myDiagram.model = new go.GraphLinksModel(modelData);
    }

    return () => myDiagram.div = null;
  }, [modelData]);

  return (
    <div ref={diagramRef} style={{ width: "100%", height: "600px" }} />
  );
}

export default GoJSFunctionalDiagram;